export default "__VITE_ASSET__CoTgpoT7__"